import React from 'react';
import { AtSignIcon, GlobeIcon, MailIcon } from 'lucide-react';
import { BRAND, FOOTER_LINE, TAGLINE, footerLinks } from '../data/sushiContent';
export function Footer() {
  return <footer className="w-full border-t border-charcoal-600 bg-charcoal-900 py-14" data-id="element-128" data-mp="32o4b2ak1486j">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-129" data-mp="32m1c310wf4po">
        <p className="font-display text-2xl font-semibold uppercase tracking-[0.14em] text-ivory-50" data-id="element-130" data-mp="36q900vzj8gmu">
          {BRAND}
        </p>
        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-body" data-id="element-131" data-mp="3ud7g3sjqpmk8">
          {FOOTER_LINE}
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] text-body" data-id="element-132" data-mp="3lem0o69kenno">
          <li className="flex items-center gap-1.5" data-id="element-133" data-mp="3qcx9cdo4is4b">
            <MailIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-134" data-mp="3qfji2gmr3do4" />
            <a href={`mailto:${footerLinks.email}`} className="transition-colors duration-150 ease-out hover:text-champagne" data-id="element-135" data-mp="2a19tbleljmwr">
              {footerLinks.email}
            </a>
          </li>
          <li className="flex items-center gap-1.5" data-id="element-136" data-mp="3gapdlka06mgi">
            <AtSignIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-137" data-mp="3gca7d7ohu1db" />
            {footerLinks.social}
          </li>
          <li className="flex items-center gap-1.5" data-id="element-138" data-mp="3q83t9ho3r77r">
            <GlobeIcon className="h-3.5 w-3.5 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-139" data-mp="3q7bww4mol5gf" />
            {footerLinks.website}
          </li>
        </ul>

        <div className="mt-10 border-t border-charcoal-600 pt-8" data-id="element-140" data-mp="32w1fp6mx48o">
          <p className="text-[13px] leading-relaxed text-muted" data-id="element-141" data-mp="hstrybs1e611">
            © La Biblia del Sabor™ 2024 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-champagne" data-id="element-142" data-mp="qujmhqh7tl31">
            “{TAGLINE}”
          </p>
        </div>
      </div>
    </footer>;
}